import React, { FC } from 'react';
import energy from 'assets/about-us/energy.png';
import eco from 'assets/about-us/eco.png';
import savings from 'assets/about-us/savings.png';
import expert from 'assets/about-us/expert.png';
import HorizontalLine from 'evcharging/components/HorizontalLine';
import Spacer from 'evcharging/components/Spacer';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';
import Container from 'evcharging/components/Container';
import ServiceCard from 'containers/about-us/ServiceCard';
import Responsible from 'evcharging/components/Responsible';
import Caption from 'evcharging/components/Caption';
import { CONTACT_US_URL } from 'config/seo/urls';

const OurServices: FC = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  const items = [
    {
      image: energy,
      title: t('about-us.complete-energy'),
      text: <>
        {t('about-us.explore-the')}
      </>,
      label: t('about-us.contact-us'),
      href: CONTACT_US_URL,
    },
    {
      image: eco,
      title: t('about-us.eco-conscious-choices'),
      text: <>
        {t('about-us.with-a')}
      </>,
      label: t('about-us.go-green'),
      href: CONTACT_US_URL,
    },
    {
      image: savings,
      title: t('about-us.maximize-your'),
      text: <>
        {t('about-us.access-exclusive')}
      </>,
      label: t('about-us.discover-savings'),
      href: CONTACT_US_URL,
    },
    {
      image: expert,
      title: t('about-us.expert-assistance'),
      text: <>
        {t('about-us.our-seasoned')}
      </>,
      label: t('about-us.contact-an'),
      href: CONTACT_US_URL,
    }
  ];

  return (
    <Container>
      <section className={styles.root}>
        <Caption>
          {t('about-us.our-comprehensive')}
        </Caption>
        <Spacer value={32} />
        <Responsible
          fractions={[50, 50]} space={48}>
          <ServiceCard {...items[0]} bottomSpace />
          <ServiceCard {...items[1]} bottomSpace />
        </Responsible>

        <HorizontalLine light />

        <Responsible fractions={[50, 50]} space={48}>
          <ServiceCard {...items[2]} topSpace />
          <ServiceCard {...items[3]} topSpace />
        </Responsible>
      </section>
    </Container>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background: #F6F8F9;
    border: 3px #E5E9EB solid;
    border-radius: 18px;
    padding: 32px;

    ${theme.breakpoints.mobile.down} {
      padding: 24px 12px;
    }
  `
});

export default OurServices;